module.exports = __webpack_public_path__ + "img/img0503.227ab528.png";